import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const dexApi = {
  config: async () => (await axios.get(`${API}/config`)).data,
  chains: async () => (await axios.get(`${API}/lifi/chains`)).data,
  tokens: async (chains) => (await axios.get(`${API}/lifi/tokens`, { params: { chains } })).data,
  quote: async (body) => (await axios.post(`${API}/lifi/quote`, body)).data,
  routes: async (body) => (await axios.post(`${API}/lifi/routes`, body)).data,
  status: async (params) => (await axios.get(`${API}/lifi/status`, { params })).data,
  markets: async () => (await axios.get(`${API}/markets`)).data,
};
